<template>
  <yxtf-dialog
    :title="$t('pc_gwnl_global_all_train').d('全部测评')"
    :visible.sync="evalVisible"
    append-to-body
  >
    <div
      v-for="(item, index) in evalList"
      :key="item.evaluationId + index"
      class="item pt20 pb20 pl24 pr24"
    >
      <div class="standard-size-16 font-weight-500 lh24 ml-6">
        {{ evalName(item.evalType,item.evaluationName || item.evalName) }}
        <yxt-tag
          v-if="item.importType === 1"
          size="mini"
          class="ml8"
          type="info"
        >
          {{ $t('pc_gwnl_global_import_eval') }}
        </yxt-tag>
      </div>
      <div class="flex align-items-center mt12">
        <div
          v-if="item.importType !==1"
          class="lh22 txt gwnl-eval-dialog__left"
        >
          <span>
            {{ ` ${$t('pc_gwnl_eval_evalRelationship')}：` }}
          </span>
          <span>
            {{ info[item.evalPattern] }}
          </span>
        </div>
        <div>
          <span class="lh22 txt">
            {{ `${$t('pc_gwnl_eval_evalProgress')}：` }}
          </span>
          <yxtf-progress
            :percentage="item.evaluationFinishRate | numberFormatter"
          />
        </div>
      </div>
      <div
        v-if="item.startTime || item.endTime"
        class="lh22 txt mt8"
      >
        <span>
          {{ `${$t('pc_gwnl_eval_lbl_evalTime')}：` }}
        </span>
        <span>
          {{ item.startTime && formatDateMd(item.startTime) }}
          ~
          {{ item.endTime && formatDateMd(item.endTime) }}
        </span>
      </div>
      <div v-if="item.evalPattern === 1">
        <yxtf-button
          v-if="(item.lockStatus !== 1 && showAttendToast(item) === '') || item.evaluationStatus === 4"
          type="primary"
          class="btn-eval"
          @click.stop="toEval(item)"
        >
          {{ item.evaluationFinishRate === 100 || item.evaluationStatus === 4 ? $t('pc_gwnl_web_homework_btn_toView') : $t('pc_gwnl_web_toEvaluate') }}
        </yxtf-button>
      </div>

      <div v-if="item.evalPattern === 3">
        <yxtf-button
          v-if="item.lockStatus !== 1 && showAttendToast(item) === ''"
          type="primary"
          class="btn-eval"
          @click.stop="toEval(item)"
        >
          {{ item.selfFinishedStatus === 1 ? $t('pc_gwnl_web_homework_btn_toView') : $t('pc_gwnl_web_toEvaluate') }}
        </yxtf-button>
      </div>
      <div v-if="item.evalPattern !== 2 && item.evaluationStatus !==4 && item.importType !== 1">
        <yxtf-popover
          v-if="item.lockStatus === 1 || showAttendToast(item) !== ''"
          placement="top-start"
          trigger="hover"
          :visible-arrow="true"
          :content="showAttendToast(item)"
        >
          <yxtf-button
            slot="reference"
            type="primary"
            class="btn-eval dis-btn"
          >
            {{ $t('pc_gwnl_web_toEvaluate') }}
          </yxtf-button>
        </yxtf-popover>
      </div>

      <div
        v-else-if="item.evalPattern === 2 && item.importType !== 1"
        class="btn-eval  lh22"
        :class="{ 'other-txt': item.evaluationFinishRate !== 100, 'txt': item.evaluationFinishRate === 100 }"
      >
        {{ item.evaluationStatus === 4 && item.evaluationFinishRate !== 100 ? $t('pc_gwnl_global_over') : item.evaluationFinishRate === 100 ? $t('pc_gwnl_training_other_finished') : $t('pc_gwnl_training_other_people') }}
      </div>
      <div
        v-if="item.importType === 1"
        class="font-size-14 text-8c btn-eval"
      >
        {{ $t('pc_gwnl_global_completed') }}
      </div>
    </div>
  </yxtf-dialog>
</template>

<script>
import dayjs from 'dayjs';
export default {
  name: 'YxtbizEvalTrainingDialog',
  name_zh: '学员端测评列表弹窗',
  props: {
    finishRequired: {
      type: Boolean,
      desc: '是否校验必须完成必修任务，才可以参加测评',
      setter: 'BooleanSetter'
    },
    finishAll: {
      type: Boolean,
      desc: '是否校验完成所有必修及选修任务，再参与训后能力测评',
      setter: 'BooleanSetter'
    },
    projectNotStart: {
      type: Boolean,
      default: false,
      desc: '是否校验项目开始时间',
      setter: 'BooleanSetter'
    },
    projectEnded: {
      type: Boolean,
      default: false,
      desc: '是否校验项目结束时间',
      setter: 'BooleanSetter'
    },
    evalList: {
      type: Array,
      default: () => [],
      desc: '显示的测评列表数据',
      setter: 'JsonSetter'
    },
    visible: {
      type: Boolean,
      default: false,
      desc: '组件的显隐',
      setter: 'BooleanSetter'
    }
  },
  data() {
    return {
      // evalVisible: false,
      info: [
        '--',
        this.$t('pc_gwnl_eval_self_eval'),
        this.$t('pc_gwnl_chart_type_peerLevel'),
        this.$t('pc_gwnl_training_self_other')
      ],
      studyInfo: {}
    };
  },
  computed: {
    // 全部测评-弹出框
    evalVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        // console.log(val)
        this.$emit('update:visible', val);
      }
    }
  },
  filters: {
    numberFormatter(progress) {
      if (progress) {
        return parseInt(progress, 10);
      } else {
        return 0;
      }
    }
  },
  methods: {
    evalLockByStudy(evaluation) {
      // attendCondition 0-完成方案中必修任务 1-完成方案中必修和选修 2-不限制）
      if (evaluation.attendCondition === 0 && this.finishRequired) {
        return this.$t('pc_gwnl_web_trainingAttendToast3'); // 请先完成必修任务，再参与训后能力测评
      } else if (evaluation.attendCondition === 1 && this.finishAll) {
        return this.$t('pc_gwnl_web_trainingAttendToast4'); // 请先完成必修及选修任务，再参与训后能力测评
      }
      return '';
    },
    // 跳转测评页面
    toEval(evaluation) {
      // 评估关系只有他评，他评未完成
      if (evaluation.evalPattern === 2 && evaluation.evaluationFinishRate !== 100) {
        this.$message.warning(this.$t('pc_gwnl_web_other_eval'));
        return;
      }
      // 评估关系只有他评，他评已完成
      if (evaluation.evalPattern === 2 && evaluation.evaluationFinishRate === 100) {
        this.$message.warning(this.$t('pc_gwnl_web_other_not_view'));
        return;
      }

      if (this.projectNotStart) {
        this.$message.warning(this.$t('pc_gwnl_web_notReachedTrainingTime'));
        return;
      }
      if (evaluation.stepStatus === 1 && this.projectEnded) {
        this.$fmessage.warning(this.$t('pc_gwnl_web_trainingEnded'));
        return;
      }
      if (evaluation.stepStatus === 1 && evaluation.evaluationStatus === 2) {
        this.$message.warning(this.$t('pc_gwnl_training_detail_study_start_train', {
          time: dayjs(evaluation.startTime).format('YYYY-MM-DD HH:mm')
        }));
        return;
      }
      if (evaluation.evaluationStatus === 2) {
        this.$fmessage.warning(this.$t('pc_gwnl_web_notReachedSkillTime'));
        return;
      }
      // 测评未完成且已结束
      if (evaluation.stepStatus === 1 && evaluation.evaluationStatus === 4) {
        this.$fmessage.warning(this.$t('pc_gwnl_web_evalFinished'));
        return;
      }
      window.open(this.urlResolve(`${window.location.protocol}//${window.location.host}/sp/speval/#/web/assess/train`, {
        evaluationId: evaluation.evaluationId,
        surveyId: evaluation.surveyId,
        userId: window.localStorage.getItem('userId'),
        evaluatorType: 1, // 完成的类型 1-自评, 2-上级，3-平级，4-下级
        relationId: evaluation.relationId,
        evaluationType: evaluation.evalSchemeType, // 取评估场景(行为、通用)
        weburl: encodeURIComponent(window.location.href)
      }));
    },

    urlResolve(path, query) {
      if (!path) {
        return '';
      }
      let url = path;
      if (query) {
        const queryArr = [];
        for (const key in query) {
          if (query.hasOwnProperty(key)) {
            queryArr.push(`${key}=${query[key]}`);
          }
        }
        if (url.indexOf('?') !== -1) {
          url = `${url}&${queryArr.join('&')}`;
        } else {
          url = `${url}?${queryArr.join('&')}`;
        }
      }
      return url;
    },
    // 训后测评未达到参与条件提示语
    showAttendToast(evaluation) {
      const LockRes = this.setLock(evaluation);
      if (LockRes) {
        return LockRes;
      }
      if (this.projectNotStart) {
        return this.$t('pc_gwnl_web_notReachedTrainingTime');
      }

      if (this.notStartFun(evaluation)) {
        return this.notStartFun(evaluation);
      }

      return '';
    },
    setLockMessageStatus(evaluation) {
      switch (evaluation.lockMessageStatus) {
        case 71: // 请先完成训前能力测评
          // 前测未开始或者已结束toast提示，否则提示弹框
          return this.$t('pc_gwnl_web_trainingAttendToast1');
        case 73:
          return this.$t('pc_gwnl_web_trainingAttendToast3');
        case 74:
          return this.$t('pc_gwnl_web_trainingAttendToast4');
      }
      return '';
    },
    setLock(evaluation) {
      const lockMsg = this.setLockMessageStatus(evaluation) || this.evalLockByStudy(evaluation);
      // evaluationStatus === 4 手动结束 stepStatus：用户参与测评状态 1-未完成 2-已完成
      if (lockMsg && evaluation.evaluationStatus !== 4 && evaluation.stepStatus !== 2) {
        return lockMsg;
      }
    },
    notStartFun(evaluation) {
      const startTime = new Date(evaluation.startTime.replace(/-/g, '/')).valueOf();
      const nowTime = new Date().valueOf();
      // evaluationStatus === 4 手动结束
      if (startTime > nowTime && evaluation.evaluationStatus !== 4) {
        return this.$t('pc_gwnl_training_detail_study_start_train', {
          time: dayjs(evaluation.startTime).format('YYYY-MM-DD HH:mm')
        });
      }
    },
    evalName(evalType, evalName) {
      switch (evalType) {
        case 1:
          return `【${this.$t('pc_gwnl_training_preTest')}】${evalName}`; // 训前测评
        case 2:
          return `【${this.$t('pc_gwnl_training_postTest')}】${evalName}`; // 训后测评
        case 3:
          return `【${this.$t('pc_gwnl_training_commonTest')}】${evalName}`; // 常规测评
        default:
          return '';
      }
    },
    formatDateMd(time) {
      return dayjs(time).format('YYYY-MM-DD');
    }
  }
};
</script>

<style lang="scss" scoped>
.item {
  position: relative;
  margin-bottom: 20px;
  background: linear-gradient(213deg, #fafbff 0%, #fff 100%, #fff 100%);
  border: 1px solid #e9e9e9;
  border-radius: 4px;
}

.item:last-child {
  margin-bottom: 0;
}

.txt {
  color: #8c8c8c;
}

.gwnl-eval-dialog__left {
  width: 180px;
}

.btn-eval {
  position: absolute;
  right: 24px;
  bottom: 20px;
}

.other-txt {
  color: #fa8c16;
}

::v-deep .yxtf-progress-bar__outer {
  min-width: 60px;
}

.dis-btn {
  background: #bdd2ff;
  border: none;
}

.ml-6 {
  margin-left: -6px;
}
</style>
